import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef, useRef, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@skatteetaten/ds-buttons';
import { dsI18n } from '@skatteetaten/ds-core-utils';
import { CancelSVGpath, Icon, FilterSVGpath } from '@skatteetaten/ds-icons';
import './styles.css';


var styles = {
    "searchContainer": "RolePickerFilterInput-module_searchContainer__o-Vzy",
    "topContainer": "RolePickerFilterInput-module_topContainer__yFxDA",
    "label": "RolePickerFilterInput-module_label__lgvnq",
    "clearButton": "RolePickerFilterInput-module_clearButton__etHYm",
    "filterIcon": "RolePickerFilterInput-module_filterIcon__v--p8",
    "inputWrapper": "RolePickerFilterInput-module_inputWrapper__wGC-J",
    "input": "RolePickerFilterInput-module_input__eShOX",
    "srOnly": "RolePickerFilterInput-module_srOnly__CFhaY"
};

const RolePickerFilterInput = /*#__PURE__*/ forwardRef(({ label, value, onChange, onClear }, ref)=>{
    const { t: formsT } = useTranslation('ds_forms', {
        i18n: dsI18n
    });
    const { t } = useTranslation('ds_overlays', {
        i18n: dsI18n
    });
    const inputRef = useRef(null);
    const [liveRegionContent, setLiveRegionContent] = useState('');
    const [showClearButton, setShowClearButton] = useState(!!value);
    useEffect(()=>{
        // Midlertidig tøm innholdet for å tvinge ny kunngjøring
        setLiveRegionContent('');
        const timeoutId = setTimeout(()=>{
            setLiveRegionContent(t('rolepicker.SearchResultUpdated'));
        }, 100); // Kort forsinkelse for å sikre at skjermleseren oppdager endringen
        return ()=>clearTimeout(timeoutId);
    }, [
        value,
        t
    ]);
    return /*#__PURE__*/ jsx("div", {
        className: styles.topContainer,
        children: /*#__PURE__*/ jsxs("div", {
            className: styles.searchContainer,
            children: [
                /*#__PURE__*/ jsx("label", {
                    className: styles.label,
                    htmlFor: 'filterInputId',
                    children: label
                }),
                /*#__PURE__*/ jsx("div", {
                    className: styles.srOnly,
                    id: 'liveSearchId',
                    children: t('rolepicker.SearchResultDescription')
                }),
                /*#__PURE__*/ jsx("div", {
                    className: styles.srOnly,
                    "aria-live": 'assertive',
                    "aria-atomic": 'true',
                    children: value ? /*#__PURE__*/ jsx("div", {
                        children: liveRegionContent
                    }) : null
                }),
                /*#__PURE__*/ jsxs("div", {
                    className: styles.inputWrapper,
                    children: [
                        /*#__PURE__*/ jsx("input", {
                            ref: inputRef,
                            id: 'filterInputId',
                            "aria-describedby": 'liveSearchId',
                            className: styles.input,
                            name: 'filter',
                            value: value,
                            type: 'search',
                            onChange: (event)=>{
                                onChange?.(event);
                                if (event.target.value.length) {
                                    setShowClearButton(true);
                                } else {
                                    setShowClearButton(false);
                                }
                            }
                        }),
                        showClearButton && /*#__PURE__*/ jsx(IconButton, {
                            type: 'reset',
                            className: styles.clearButton,
                            size: 'extraSmall',
                            svgPath: CancelSVGpath,
                            title: formsT('searchfield.ClearButtonTitle'),
                            onClick: (event)=>{
                                onClear?.(event);
                                setShowClearButton(false);
                                inputRef.current?.focus();
                            }
                        }),
                        /*#__PURE__*/ jsx(Icon, {
                            svgPath: FilterSVGpath,
                            className: styles.filterIcon
                        })
                    ]
                })
            ]
        })
    });
});
RolePickerFilterInput.displayName = 'RolePickerFilterInput';

export { RolePickerFilterInput };
